(function () {
  console.log("scroll-to-variant loaded"); // temporary debug log

  const isMobile = () => window.matchMedia("(max-width: 749px)").matches;

  // Find the element that actually scrolls (body or modal container)
  function getScrollContainer(el) {
    let n = el;
    while (n && n !== document.body) {
      const s = getComputedStyle(n);
      if (/(auto|scroll)/.test(s.overflowY) && n.scrollHeight > n.clientHeight)
        return n;
      n = n.parentElement;
    }
    return document.scrollingElement || document.documentElement;
  }

  // Dynamically measure sticky header + announcement bars
  function getStickyOffset() {
    const selectors = [
      ".shopify-section-header-sticky",
      ".header-wrapper",
      "header.site-header",
      ".announcement-bar",
      ".AnnouncementBar",
    ];
    let h = 0;
    document.querySelectorAll(selectors.join(",")).forEach((el) => {
      h += el?.offsetHeight || 0;
    });
    return h + 60; // add small buffer
  }

  // Find the media element or gallery section to scroll to
  function findTarget(root, mediaId) {
    return (
      (mediaId && root.querySelector(`[data-media-id='${mediaId}']`)) ||
      root.querySelector("media-gallery") ||
      root.querySelector(".product__media-list") ||
      root.querySelector(".Product__Gallery") ||
      root.querySelector("[data-media-gallery]") ||
      root.querySelector(".product-gallery")
    );
  }

  // Actually perform the smooth scroll
  function doScroll(formEl, variant) {
    if (!isMobile()) return;

    const section = formEl?.closest("[id^='shopify-section-']") || document;
    const mediaId = variant?.featured_media?.id;
    const target = findTarget(section, mediaId);
    if (!target) return;

    const scroller = getScrollContainer(target);
    const offset = getStickyOffset();

    const rect = target.getBoundingClientRect();
    const scrollerTop =
      scroller === document.scrollingElement || scroller === document.documentElement
        ? window.scrollY
        : scroller.scrollTop;

    const y = rect.top + scrollerTop - offset;
    scroller.scrollTo({ top: y, behavior: "smooth" });
  }

  // Core handler for variant events
  function handle(detail, fallbackEl) {
    const form =
      detail?.productForm ||
      detail?.form ||
      fallbackEl?.closest("form") ||
      document.querySelector("form[action*='/cart/add']");

    const variant =
      detail?.variant ||
      form?.currentVariant ||
      (form?.dataset?.currentVariant &&
        JSON.parse(form.dataset.currentVariant)) ||
      null;

    // Delay one frame so image updates first
    requestAnimationFrame(() => doScroll(form, variant));
  }

  // Listen for theme events
  document.addEventListener("variant:change", (e) => handle(e.detail));
  document.addEventListener("variant:changed", (e) => handle(e.detail));

  // Fallback: direct listeners on option controls
  function wireFallback() {
    document
      .querySelectorAll("product-form, form[action*='/cart/add']")
      .forEach((form) => {
        form
          .querySelectorAll(
            "variant-radios, variant-selects, select[name^='options'], input[name^='options']"
          )
          .forEach((c) => c.addEventListener("change", () => handle(null, c)));
      });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", wireFallback);
  } else {
    wireFallback();
  }
})();
